module.exports = __webpack_public_path__ + "media/images/home/concept_scene_3_sp-8d80032b5803cf99a01631e4e8e04c9b.png";